import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRacingFlag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRacingFlag"><Path fillRule="evenodd" clipRule="evenodd" d="M21 17H5V21H3V3H21V17ZM7 13V15H9V13H7ZM11 13V15H13V13H11ZM15 13V15H17V13H15ZM5 11V13H7V11H5ZM9 11V13H11V11H9ZM13 11V13H15V11H13ZM17 11V13H19V11H17ZM7 9V11H9V9H7ZM11 9V11H13V9H11ZM15 9V11H17V9H15ZM5 7V9H7V7H5ZM9 7V9H11V7H9ZM13 7V9H15V7H13ZM17 7V9H19V7H17ZM7 5V7H9V5H7ZM11 5V7H13V5H11ZM15 5V7H17V5H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRacingFlag;
